
import Vue from 'vue';
import Component from 'vue-class-component';
import BaseLookup from './BaseLookup';
import TLookupSkin from './LookupSkin.vue';

@Component({
  name: 'ContactLookup',
  components: {
    TLookupSkin,
  },
})
export default class ContactLookup extends BaseLookup {
  dialogVisible = false;

  suggestionControllerName() {
    return 'Contact';
  }

  keyPrefix() {
    return 'Contact';
  }

  openDialog() {
    this.dialogVisible = true;
  }

  handleSelect(val) {
    this.addItem({
      key: val.key,
      title: val.value,
    });
  }

  linkClick(contactId, row) {
    const item = {
      key: `${this.keyPrefix()}-${contactId}`,
      title: `${row.NAME.value} ${row.SURNAME.value}`,
    };
    this.addItem(item);
    if (!this.multipleSelection) {
      this.dialogVisible = false;
    }
  }
}
